// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"el_a bhc_a bhc_x bhc_j bhc_u bhc_bc bhc_pp bhc_up"};